"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
exports.shadows = {
    topMedium: '0 -2px 10px 1px rgba(0,0,0,0.25)',
    bottomSmall: '0 4px 4px -4px rgba(0, 0, 0, .15)',
    small: '0 0 4px rgba(0, 0, 0, .15)',
    large: '0px 2px 4px rgba(0,0,0,.52)',
    subLinksList: '0px 16px 40px 0px rgba(0, 0, 0, 0.10)',
    footerCard: '0 2px 4px 1px rgba(0,0,0,0.1)',
    cardShadow: '0 3px 5px 1px rgba(0,0,0,0.06)',
    homeSearchFormWrap: '0px 2px 7px rgba(0,0,0,0.218859)',
    landDropdown: '0 4px 14px 0 rgba(0,0,0,0.17)',
    tooltip: '0 4px 8px 2px rgba(0,0,0,0.2)',
    blockShadow: '0 4px 7px 0 rgba(0,0,0,0.1)',
    notificationShadow: '0 2px 7px 2px rgba(0,0,0,0.32)',
};
//# sourceMappingURL=shadows.js.map